import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { LoadingScreen } from '../ui/LoadingScreen'

interface PrivateRouteProps {
  children: React.ReactNode
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, mustChangePassword } = useAuth()
  const location = useLocation()

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return <LoadingScreen message="Verificando autenticación..." />
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Si debe cambiar contraseña, redirigir a create-password
  if (mustChangePassword) {
    return <Navigate to="/create-password" replace />
  }

  // Renderizar children solo cuando esté autenticado y no esté cargando y no debe cambiar contraseña
  return <>{children}</>
}

export default PrivateRoute
